import { SignalStatus } from './signal-lifecycle.enum';

export const SIGNAL_STATUS_SORT_ORDER = [
  SignalStatus.CONFIRMED_VULNERABILITY,
  SignalStatus.POTENTIAL_VULNERABILITY,
  SignalStatus.BLOCKED,
  SignalStatus.PENDING_ENRICHMENT,
  SignalStatus.FAILED_ENRICHMENT,
  SignalStatus.DISPROVEN_VULNERABILITY,
  SignalStatus.DUPLICATE,
] as const;

export const FINDING_SEVERITY_SORT_ORDER = [
  'Critical',
  'High',
  'Medium',
  'Low',
  'Info',
] as const;

export const resolveSortRank = <TValue extends string>({
  order,
  value,
}: {
  order: readonly TValue[];
  value: string | null | undefined;
}): number => {
  const rank = order.findIndex((candidate) => candidate === value);

  return rank === -1 ? order.length : rank;
};
